import { SET_SERVICE_AVAILABLE, SET_SERVICE_ACTIVE, SET_SERVICE_COUNTRY } from '../constants/types';

export const setServiceAvailable = available => {
  return {
    type: SET_SERVICE_AVAILABLE,
    available,
  };
};

export const setServiceCountry = country => {
  return {
    type: SET_SERVICE_COUNTRY,
    country,
  };
};

export const setServiceActive = active => {
  return {
    type: SET_SERVICE_ACTIVE,
    active,
  };
};
